import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from '@mui/material';
import { ServePreferences } from '../../../../../../../Models/Departments/Details/ServePreferences';
import CheckboxInput from '../../../../../../AddLocation/Components/UI/CheckboxInput';
import { ExpandMore } from '@mui/icons-material';
import * as Styles from '../../../../../../../assets/styles/appStyles';
import { accordionSummaryText } from '../../../../../Styles/MainInformationTabStyles';
import { gridContainer, infoGridItem } from '../../../../../Styles/CustodianAddressDetailsStyles';
import GenericInput from '../../../../../../AddLocation/Components/UI/GenericInput';

export default function DocumentInfo({
  servePreferences,
}: {
  servePreferences: ServePreferences | undefined;
}) {
  return (
    <Grid rowSpacing={3} container sx={gridContainer} spacing={2}>
      <Grid container item rowSpacing={3}>
        <Grid item xs={12} sx={infoGridItem}>
          <Typography align="left" sx={Styles.labelTitle}>
            Documents
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <CheckboxInput
                label="Authorization with Subpoena Required"
                keyName={`servePreferences.isAuthorizationWithSubpoenaRequired`}
                checked={servePreferences?.isAuthorizationWithSubpoenaRequired}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>

            <Grid item xs={6}>
              <CheckboxInput
                label="POA for Subpoena"
                keyName={`servePreferences.isPOAForSubpoena`}
                checked={servePreferences?.isPOAForSubpoena}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>

            <Grid item xs={6}>
              <CheckboxInput
                label="HIPPA Authorization Original"
                keyName={`servePreferences.isHIPPAAuthorizationOriginal`}
                checked={servePreferences?.isHIPPAAuthorizationOriginal}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>

            <Grid item xs={6}>
              <CheckboxInput
                label="Facility Specific Authorization"
                keyName={`servePreferences.isFacilitySpecificAuthorization`}
                checked={servePreferences?.isFacilitySpecificAuthorization}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />
              {servePreferences?.isFacilitySpecificAuthorization && (
                <GenericInput
                  name="facilitySpecificAuthorizationNotes"
                  label="Facility Specific Authorization Notes"
                  placeholder="Notes"
                  key={`servePreferences.facilitySpecificAuthorizationNotes`}
                  maxLength={150}
                  value={servePreferences?.facilitySpecificAuthorizationNotes}
                  onChange={(e: any) => { }}
                  onBlur={() => { }}
                  disabled={true}
                />
              )}
            </Grid>

            <Grid item xs={6}>
              <CheckboxInput
                label="Accept LOR"
                keyName={`servePreferences.isAcceptLOR`}
                checked={servePreferences?.isAcceptLOR}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />

              {servePreferences?.isAcceptLOR ? (
                <GenericInput
                  name="acceptLORNotes"
                  label="Accept LOR Notes"
                  placeholder="Notes"
                  key={`servePreferences.acceptLORNotes`}
                  maxLength={150}
                  value={servePreferences?.acceptLORNotes}
                  onChange={(e: any) => { }}
                  onBlur={() => { }}
                  disabled={true}
                />
              ) : (
                ''
              )}
            </Grid>
            <Grid item xs={6}>
              <CheckboxInput
                label="SOA for Subpoena"
                keyName={`servePreferences.isSOAForSubpoena`}
                checked={servePreferences?.isSOAForSubpoena}
                onChange={(e: any) => {}}
                onBlur={() => {}}
                disabled={false}
              />
            </Grid>
            <Grid item xs={6}>
              <CheckboxInput
                label="Copy Service"
                keyName={`servePreferences.isCopyService`}
                checked={servePreferences?.isCopyService}
                onChange={(e: any) => {}}
                onBlur={() => {}}
                disabled={false}
              />
              {servePreferences?.isCopyService ? (
                <GenericInput
                  name="CopyServiceNotes"
                  label="Copy Service Notes"
                  placeholder="Copy Service Notes"
                  maxLength={150}
                  value={servePreferences?.copyServiceNotes}
                  onChange={(e: any) => {}}
                  onBlur={() => {}}
                  disabled={true}
                />
              ) : (
                ''
              )}
            </Grid>
            <Grid item xs={6}>
              <CheckboxInput
                label="Additional Facility Specific Documentation"
                keyName={`servePreferences.isAdditionalFacilitySpecificDocumentation`}
                checked={
                  servePreferences?.isAdditionalFacilitySpecificDocumentation
                }
                onChange={(e: any) => {}}
                onBlur={() => {}}
                disabled={false}
              />
              {servePreferences?.isAdditionalFacilitySpecificDocumentation ? (
                <GenericInput
                  name="additionalFacilitySpecificDocumentationNotes"
                  label="Additional Facility Specific Documentation Notes"
                  placeholder="Additional Facility Specific Documentation Notes"
                  maxLength={150}
                  value={
                    servePreferences?.additionalFacilitySpecificDocumentationNotes
                  }
                  onChange={(e: any) => {}}
                  onBlur={() => {}}
                  disabled={true}
                />
              ) : (
                ''
              )}
            </Grid>
            <Grid item xs={6}>
              <CheckboxInput
                label="Requires Death Certificate"
                keyName={`servePreferences.isRequiresDeathCertificate`}
                checked={servePreferences?.isRequiresDeathCertificate}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>
            <Grid item xs={6}>
              <CheckboxInput
                label="Requires Estate Letter"
                keyName={`servePreferences.isRequiresEstateLetter`}
                checked={servePreferences?.isRequiresEstateLetter}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>
            <Grid item xs={6}>
              <CheckboxInput
                label="Requires Certification of Non-Objection"
                keyName={`servePreferences.isRequiresCertificationOfNonObjection`}
                checked={servePreferences?.isRequiresCertificationOfNonObjection}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>
            <Grid item xs={6}>
              <CheckboxInput
                label="Requires Certification of Notice"
                keyName={`servePreferences.isRequiresCertificationOfNotice`}
                checked={servePreferences?.isRequiresCertificationOfNotice}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>
            <Grid item xs={6}>
              <CheckboxInput
                label="Requires Third Party Listed on Auth/Subpoena"
                keyName={`servePreferences.isRequiresThirdPartyListedOnAuthSubpoena`}
                checked={servePreferences?.isRequiresThirdPartyListedOnAuthSubpoena}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>
            <Grid item xs={6}>
              <CheckboxInput
              label="Requires Record Type and Scope in Auth"
              checked={servePreferences?.isRequiresRecordTypeAndScopeInAuth}
              keyName={`servePreferences.isRequiresRecordTypeAndScopeInAuth`}
              onChange={(e: any) => {}}
              onBlur={() => {}}
              disabled={false}
            />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
